module.exports = __webpack_public_path__ + "static/media/fly0076.2cb1c59f.webp";